import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Dropdown, Menu, Label } from 'semantic-ui-react';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const DropdownMenuLinks = ({ text, options = [], elmId }) => (_jsxs(Menu, { compact: true, fluid: true, className: cx('dropdown-menu'), children: [_jsx(Label, { style: { display: 'none' }, id: `${elmId}_menu`, children: text }), _jsx(Dropdown, { "data-elm-id": `${elmId}_dropdown`, "aria-labelledby": `${elmId}_menu`, scrolling: true, fluid: true, text: text, className: cx('link', 'item'), children: _jsx(Dropdown.Menu, { children: options.map((item, index) => (_jsx("a", { className: 'item', href: item.href, "data-elm-id": `${elmId}_links_${index + 1}`, role: 'option', children: item.text }, index))) }) })] }));
DropdownMenuLinks.propTypes = {
    text: PropTypes.string.isRequired,
    options: PropTypes.array,
    elmId: PropTypes.string.isRequired,
};
DropdownMenuLinks.propTypes = {
    text: PropTypes.string.isRequired,
};
export default DropdownMenuLinks;
//# sourceMappingURL=index.js.map